import { render } from "./BuyCryptoComponent.vue?vue&type=template&id=22aed32e&ts=true"
import script from "./BuyCryptoComponent.vue?vue&type=script&lang=ts"
export * from "./BuyCryptoComponent.vue?vue&type=script&lang=ts"

import "./BuyCryptoComponent.vue?vue&type=style&index=0&id=22aed32e&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/buyCrypto/BuyCryptoComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22aed32e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22aed32e', __exports__)) {
    api.reload('22aed32e', __exports__)
  }
  
  module.hot.accept("./BuyCryptoComponent.vue?vue&type=template&id=22aed32e&ts=true", () => {
    api.rerender('22aed32e', render)
  })

}


export default __exports__